import {DarkModeOutlined, LightModeOutlined} from "@mui/icons-material";
import {
  IconButton,
  Tooltip,
  useTheme,
} from "@mui/material";
import {useContext, useMemo} from "react";
import {ThemeContext} from "../context/ThemeContext";
import {useTranslation} from "react-i18next";

export default function ThemeSwitch() {
  const theme = useTheme();
  const {switchColorMode} = useContext(ThemeContext);
  const activateName = useMemo(
    () => (theme.palette.mode === "dark" ? "Light" : "Dark"),
    [theme]
  );
  const {t} = useTranslation("common");

  return (
    <>
      <Tooltip title={t(`activate${activateName}Mode`)}>
        <IconButton
          onClick={switchColorMode}
          sx={{
            p: 1,
            border: `1px ${theme.palette.text.disabled} solid`,
          }}
          size="small"
          color="inherit"
        >
          {theme.palette.mode === "dark" ? (
            <LightModeOutlined />
          ) : (
            <DarkModeOutlined color="secondary" />
          )}
        </IconButton>
      </Tooltip>
    </>
  );
}